module.exports = __webpack_public_path__ + "static/media/img-find-us-riyadh-s@3x.1371fe6d.png";